export default "__VITE_ASSET__be8a9572__"